<input
    type="text"
    fieldSize="large"
    class="sidebar-search"
    placeholder="Cauta menu"
    nbInput
    [(ngModel)]="searchText"
    (input)="onInput()"
    *ngIf="isSidebarExtended"/>
<nb-menu [items]="menu"></nb-menu>
